<nav>
  <button matIconButton class="otp-button drawer-toggle" (click)="snav().toggle()" aria-label="Отвори меню" i18n-aria-label><mat-icon svgIcon="otp-drawer-toggle" /></button>
  <a class="logo" #anchorEl routerLink="/home" [replaceUrl]="isMortgageApplicationPath()" (click)="removeFocus(anchorEl)" aria-label="Начало" i18n-aria-label>
    <!-- Using img fixes a bug relate to heavy svg icons (if svg is heavy and the page to be loaded has many elements, the svg flickers) -->
    <img [ngSrc]="'media/dskhome-logo.svg'" width="152" height="32" alt="Начало" i18n-alt priority />
  </a>
  <button matIconButton class="otp-button main-menu-toggle" [matMenuTriggerFor]="mainMenu" aria-label="Отвори меню" i18n-aria-label>
    <mat-icon svgIcon="otp-arrow-down" />
  </button>

  <div class="horizontal-menu">
    <a matButton routerLink="/listings/search" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="active-link" class="otp-button" i18n>Намери имот</a>
    <!-- <a matButton routerLink="/credit-requests" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="active-link" class="otp-button" data-text="Продай имот" i18n>Продай имот</a> -->
    <a matButton routerLink="/mortgage-application" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="active-link" class="otp-button" i18n>Кандидатствай за кредит</a>
   <button matButton class="otp-button dropdown" [class.active-link]="isPurchaseSubmenuRouteActive()" [matMenuTriggerFor]="purchaseMenu"><span i18n>Планирай покупка</span><mat-icon iconPositionEnd svgIcon="down-arrow" /></button>
  </div>

  <div class="section--right">
    <a routerLink="/schedule-appointment" [replaceUrl]="isMortgageApplicationPath()" matButton="filled" class="otp-button schedule-appointment-button"
      data-otp-color="orange" i18n>
      Ипотечна консултация
    </a>

    <!--    TODO: Activate when the pages are ready-->
<!--    <button matIconButton class="otp-button language-button" (click)="toggleLocale()" aria-label="Смени езика" i18n-aria-label>-->
<!--      <mat-icon [svgIcon]="otpFlagSvgName" />-->
<!--    </button>-->

    <div class="login-register-wrapper">
      @if (dskHomeUserStore.isLoggedIn()) {

        <div class="user-badge-wrapper">
          <span class="user-badge-initials otp-p otp-p__body--highlight" aria-hidden="true">
            {{ dskHomeUserStore.userInitials() }}
          </span>
          <button matIconButton
                  class="otp-button dropdown"
                  aria-label="Потребителско меню"
                  i18n-aria-label
                  [matMenuTriggerFor]="userMenu">
            <mat-icon iconPositionEnd svgIcon="down-arrow" />
          </button>
        </div>

      } @else {

        <!-- Full size buttons are shown on bigger resolutions-->
        <a matButton
           data-otp-color="green"
           class="otp-button auth-full-size-button green"
           routerLink="/authentication/login"
           routerLinkActive="active-link"
           i18n
           [replaceUrl]="isMortgageApplicationPath()">Вход</a>
        <a matButton="outlined"
           class="otp-button auth-full-size-button"
           routerLink="/authentication/register"
           i18n
           [replaceUrl]="isMortgageApplicationPath()">
          Регистрация
        </a>

        <!-- Icon button is shown on small resolutions-->
        <a matIconButton
           class="otp-button auth-icon-button"
           aria-label="Вход"
           i18n-aria-label
           routerLink="/authentication/login"
           [replaceUrl]="isMortgageApplicationPath()">
          <mat-icon svgIcon="user" />
        </a>
      }
    </div>
  </div>
</nav>

<!-- Main dropdown menu-->
<mat-menu #mainMenu="matMenu" class="dskhome-dropdown-menu hide-scrollbar"
          aria-label="Главно меню" i18n-aria-label>

  <!--  Listings menu-->
  <a mat-menu-item class="menu-item-small-padding"
     routerLink="/listings/search"
     [replaceUrl]="isMortgageApplicationPath()"
     routerLinkActive="is-active"
     aria-label="Намери имот" i18n-aria-label>
    <mat-icon svgIcon="otp-search-house" class="menu-item-leading-icon icon-with-green-highlight"></mat-icon>
    <span i18n>Намери имот</span>
  </a>

  <!-- <a mat-menu-item class="menu-item-small-padding"
     routerLink="/credit-requests"
     [replaceUrl]="isMortgageApplicationPath()"
     routerLinkActive="is-active"
     aria-label="Продай имот" i18n-aria-label>
    <mat-icon svgIcon="otp-home-own" class="menu-item-leading-icon icon-with-green-highlight"></mat-icon>
    <span i18n>Продай имот</span>
  </a> -->

  <!--  Mortgage journeys menu-->
  <a mat-menu-item class="menu-item-small-padding"
     routerLink="/mortgage-application"
     [replaceUrl]="isMortgageApplicationPath()"
     routerLinkActive="is-active"
     aria-label="Кандидатствай за кредит" i18n-aria-label>
    <mat-icon svgIcon="otp-money-document" class="menu-item-leading-icon icon-with-green-highlight"></mat-icon>
    <span i18n>Кандидатствай за кредит</span>
  </a>

  <!-- Purchase dropdown trigger -->
 <button mat-menu-item class="menu-item-small-padding"
         [matMenuTriggerFor]="purchaseMenu"
         [class.is-active]="isPurchaseSubmenuRouteActive()"
         aria-label="Планирай покупка" i18n-aria-label>
   <mat-icon svgIcon="otp-home-star" class="menu-item-leading-icon icon-with-green-highlight"></mat-icon>
   <ng-container>
     <span i18n>Планирай покупка</span>

     <!-- &lt;!&ndash; Add custom icon for the submenu trigger and use the prepared `menu-item-submenu-icon` class for the syles. &ndash;&gt; -->
     <mat-icon svgIcon="otp-arrow-right" class="menu-item-submenu-icon"></mat-icon>
   </ng-container>
 </button>
</mat-menu>

<!-- Purchase dropdown menu -->
<mat-menu #purchaseMenu="matMenu" class="dskhome-dropdown-menu hide-scrollbar">
  <!--    TODO: Activate when the pages are ready-->
  <!-- <a mat-menu-item routerLink="/home" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active" aria-label="Видове ипотечни кредити" i18n i18n-aria-label>Видове ипотечни кредити</a>
  <a mat-menu-item routerLink="/calculator/form" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active" aria-label="Ипотечни калкулатори" i18n i18n-aria-label>Ипотечни калкулатори</a>
  <a mat-menu-item routerLink="/calculator/results" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active" aria-label="Как да взема ипотека" i18n i18n-aria-label>Как да взема ипотека</a>
  <a mat-menu-item routerLink="/calculator" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active" aria-label="Застраховки" i18n i18n-aria-label>Застраховки</a> -->
  <a mat-menu-item routerLink="/property-appraisal" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active" aria-label="Автоматизирана пазарна оценка" i18n i18n-aria-label>Автоматизирана пазарна оценка</a>
  <!-- <a mat-menu-item routerLink="/market-analysis" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active" aria-label="Анализ на имотния пазар" i18n i18n-aria-label>Анализ на имотния пазар</a> -->
</mat-menu>

<!-- User profile dropdown menu -->
<mat-menu #userMenu="matMenu" class="dskhome-dropdown-menu">
<!--  TODO: Include the prepared navigations when the pages are ready-->
<!--  <a mat-menu-item class="menu-item-small-padding"-->
<!--     routerLink="/home"-->
<!--     [replaceUrl]="isMortgageApplicationPath()"-->
<!--     routerLinkActive="is-active"-->
<!--     aria-label="Моят профил" i18n-aria-label>-->
<!--    <mat-icon svgIcon="user" class="menu-item-leading-icon icon-with-transparent-highlight"></mat-icon>-->
<!--    <span i18n>Моят профил</span>-->
<!--  </a>-->

<!--  <a mat-menu-item class="menu-item-small-padding"-->
<!--     routerLink="/notifications"-->
<!--     [replaceUrl]="isMortgageApplicationPath()"-->
<!--     routerLinkActive="is-active"-->
<!--     aria-label="Известия" i18n-aria-label>-->
<!--    <mat-icon svgIcon="otp-alarm-bell" class="menu-item-leading-icon icon-with-transparent-highlight"></mat-icon>-->
<!--    <span i18n>Известия</span>-->
<!--  </a>-->

<!--  <a mat-menu-item class="menu-item-small-padding"-->
<!--     routerLink="/insurances"-->
<!--     [replaceUrl]="isMortgageApplicationPath()"-->
<!--     routerLinkActive="is-active"-->
<!--     aria-label="Настройки" i18n-aria-label>-->
<!--    <mat-icon svgIcon="otp-gear" class="menu-item-leading-icon icon-with-transparent-highlight"></mat-icon>-->
<!--    <span i18n>Настройки</span>-->
<!--  </a>-->

<!--  <a mat-menu-item class="menu-item-small-padding"-->
<!--     routerLink="/calculator"-->
<!--     [replaceUrl]="isMortgageApplicationPath()"-->
<!--     routerLinkActive="is-active"-->
<!--     aria-label="Помощ" i18n-aria-label>-->
<!--    <mat-icon svgIcon="otp-question-circle" class="menu-item-leading-icon icon-with-transparent-highlight"></mat-icon>-->
<!--    <span i18n>Помощ</span>-->
<!--  </a>-->

  <!-- Change language-->
<!--  <button mat-menu-item class="menu-item-small-padding" (click)="toggleLocale()"-->
<!--          aria-label="Смяна на език" i18n-aria-label>-->
<!--    <mat-icon [svgIcon]="otpFlagSvgName" class="menu-item-leading-icon icon-with-transparent-highlight"></mat-icon>-->
<!--    {{ nextLanguageCode | uppercase }}-->
<!--  </button>-->

  <!-- Favorite listings-->
  <a mat-menu-item class="menu-item-small-padding"
     routerLink="/listings/favorites"
     routerLinkActive="is-active"
     [replaceUrl]="isMortgageApplicationPath()">
    <mat-icon svgIcon="otp-heart" class="menu-item-leading-icon icon-with-green-highlight" />
    <span i18n>Запазени обяви</span>
  </a>

  <mat-divider></mat-divider>

  <!-- Profile verification-->
  <a mat-menu-item class="menu-item-small-padding"
     routerLink="/user-verification"
     routerLinkActive="is-active"
     [state]="{ verificationJourneyDashboardOpenedByClick: true }"
     [replaceUrl]="isMortgageApplicationPath()">
    <mat-icon svgIcon="otp-profile-role-authority" class="menu-item-leading-icon icon-with-green-highlight" />
    <span i18n>Верификация на профила</span>
  </a>

  <!-- Change password-->
  <a mat-menu-item class="menu-item-small-padding"
     routerLink="/authentication/change-password"
     routerLinkActive="is-active"
     [replaceUrl]="isMortgageApplicationPath()">
    <mat-icon svgIcon="otp-lock" class="menu-item-leading-icon icon-with-green-highlight" />
    <span i18n>Смяна на парола</span>
  </a>

  <!-- Backoffice panel-->
  @if (dskHomeUserStore.isBackOfficer()) {
    <a mat-menu-item class="menu-item-small-padding"
       routerLink="/backoffice"
       routerLinkActive="is-active"
       [replaceUrl]="isMortgageApplicationPath()">
      <mat-icon svgIcon="otp-profile-admin" class="menu-item-leading-icon icon-with-green-highlight" />
      <span i18n>Администратор</span>
    </a>
  }

  <mat-divider></mat-divider>

  <!--  Logout-->
  <button mat-menu-item class="menu-item-small-padding"
          (click)="logout()">
    <mat-icon svgIcon="otp-sell" class="menu-item-leading-icon icon-with-green-highlight" />
    <span i18n>Изход</span>
  </button>
</mat-menu>
